export default __webpack_public_path__ + "static/media/tech_blog.e46066aa.png";